import { render, staticRenderFns } from "./receipt-table.vue?vue&type=template&id=5bed86d1&scoped=true&"
import script from "./receipt-table.vue?vue&type=script&lang=js&"
export * from "./receipt-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed86d1",
  null
  
)

export default component.exports